import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Home from "./pages/Home";
import About from "./pages/About";
import BlogPage from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";
import FAQ from "./pages/FAQ";
import ScrollToTop from "./components/ScrollToTop";
import MetaTagsUpdater from "./components/MetaTagsUpdater"; // Import the new component
import { EventPage } from "./components/EventPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import GiftSuccess from "./pages/GiftSuccess";
import GiftCancelled from "./pages/GiftCancelled";

function App() {
  return (
    <Router>
      {/* Add ScrollToTop and MetaTagsUpdater just inside the Router */}
      <ScrollToTop />
      <MetaTagsUpdater />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/event/*" element={<EventPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/gift-success" element={<GiftSuccess />} />
        <Route path="/gift-cancelled" element={<GiftCancelled />} />
      </Routes>
    </Router>
  );
}

export default App;
